import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

export interface InquiryPayload {
  name: string
  email: string
  countryCode: string
  phone: string
}

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private apiUrl = `${environment.apiBaseUrl}/inquiry`

  constructor(private http: HttpClient) {}

  submitInquiry(payload: InquiryPayload): Observable<any> {
    return this.http.post(this.apiUrl, payload)
  }

  getCountries(): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/auth/country/all`)
  }
}
